import React, { Component } from "react";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import { Badge, ClickAwayListener, withStyles } from "@material-ui/core";
import styles from "../../headerStyles";
import { IconButton } from "@material-ui/core";
import Tooltip from "../../../common/StyledToolTip";
import NotificationPanel from "./NotificationPanel/index";
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import withWidth from "@material-ui/core/withWidth";

const localStyles = (theme) => ({
  unreadCountBadge: {
    height: 15,
    minWidth:15,
    backgroundColor: theme.error,
    color: theme.white
  },
  desktopContainer: {
    top: 43,
  },
  tabContainer: {
    top: 45,
    right: -28,
  },
});

@inject("DispatchStore")
@observer
export class Notifications extends Component {
  render() {
    const { classes, width, showNotification, switchNotificationPanel, openDriverChatBox } =
      this.props;
    const unreadCount =
      this.props.DispatchStore.unreadDriverNotifications.length;
    return (
     
        <div>
          <div
            className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
          >
            <IconButton
              color="inherit"
              className={classes.muiIconButtonStyle}
              onClick={() => switchNotificationPanel()}
              data-automationid="settings-icon"
            >
              <Tooltip title="Notifications">
                <Badge
                  badgeContent={unreadCount}
                  classes={{ badge: classes.unreadCountBadge }}
                  color="primary"
                >
                  <NotificationsOutlinedIcon />
                </Badge>
              </Tooltip>
            </IconButton>
          </div>
          {showNotification ? (
            <ClickAwayListener onClickAway={() => switchNotificationPanel(false)}>
            <NotificationPanel
              data={this.props.DispatchStore.unreadDriverNotifications}
              openDriverChatBox={openDriverChatBox}
              containerStyles={
                ["xl", "lg"].includes(width)
                  ? classes.desktopContainer
                  : classes.tabContainer
              }
            />
            </ClickAwayListener>
          ) : null}
        </div>
    );
  }
}
export default compose(
  withWidth(),
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(Notifications);
